import axios from "axios";
import { compress } from "../helpers/common.helper";
const apiUri = import.meta.env.GATEWAY_URI;

export default function useCompanies() {
  const getCompany = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/companies/${id}`);
    return result.data?.data;
  };

  const queryCompany = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/companies/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const uploadCompanyDBD = async (companyId, file) => {
    let data = new FormData();
    data.append("file", file, "profile");

    const result = await axios.patch(
      `${apiUri}/api/v1/companies/${companyId}/dbd/upload`,
      data,
      {
        maxBodyLength: Infinity,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const uploadLogo = async (companyId, file) => {
    let data = new FormData();
    data.append("file", file, "profile");

    const result = await axios.patch(
      `${apiUri}/api/v1/companies/${companyId}/logo/upload`,
      data,
      {
        maxBodyLength: Infinity,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const uploadBanner = async (companyId, file) => {
    let data = new FormData();
    data.append("file", file, "profile");

    const result = await axios.patch(
      `${apiUri}/api/v1/companies/${companyId}/banner/upload`,
      data,
      {
        maxBodyLength: Infinity,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const getStatistics = async (companyId) => {
    const {
      data: { data },
    } = await axios.get(`${apiUri}/api/v1/companies/${companyId}/statistics`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return data;
  };

  const patchCompany = async (companyId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/companies/${companyId}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const queryPurchases = async (userId, filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/companies/${userId}/purchases/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  return {
    getCompany,
    queryCompany,
    uploadCompanyDBD,
    getStatistics,
    uploadLogo,
    uploadBanner,
    patchCompany,
    queryPurchases,
  };
}
